import { logger } from '../../common/logger';
import { brazeLoadScriptSrc } from './constants';

export function loadBraze(onScriptLoad: () => void) {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = brazeLoadScriptSrc;
  script.onerror = e => {
    logger.error({ error: e }, 'Loading braze failed.');
  };
  script.onload = onScriptLoad;
  document.head.appendChild(script);
}
